import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SystemConfigurationService } from '../../../pages/system-configuration/system-configuration.service';

@Component({
  selector: 'app-new-hsc-modal',
  templateUrl: './new-hsc-modal.component.html',
  styleUrls: ['./new-hsc-modal.component.scss'],
})
export class NewHscModalComponent implements OnInit {
  @Input() settingVisible: boolean = false;
  @Input() fileTypeList: any[] = [];

  @Output() fileList = new EventEmitter();
  @Output() modalStatus = new EventEmitter();

  version: 0 | 1 | 2 = 0;

  constructor(private systemConfigurationService: SystemConfigurationService) {}

  ngOnInit(): void {
    this.getVersion();
  }

  getVersion() {
    const keys = ['HSC_VERSION'];
    this.systemConfigurationService.getSettingsByCodes(keys.join(',')).subscribe(
      (data: any) => {
        this.version = data?.HSC_VERSION?.settingValue || 1;
      },
      () => {
        this.version = 1;
      },
    );
  }
}
